import { faBolt, faFile, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

const Services = () => {
  const services = [
    {
      icon: faMagnifyingGlass,
      title: "Visa Assessment",
      description: "Professional evaluation of your visa eligibility and requirements",
      gradient: "from-blue-500 to-cyan-500",
      features: ["Eligibility Check", "Document List", "Success Probability"]
    },
    {
      icon: faFile,
      title: "Document Preparation",
      description: "Complete assistance with document collection and verification",
      gradient: "from-purple-500 to-blue-500",
      features: ["Document Review", "Formatting Help", "Verification Support"]
    },
    {
      icon: faBolt,
      title: "Express Processing",
      description: "Fast-track visa processing for urgent travel needs",
      gradient: "from-green-500 to-cyan-500",
      features: ["Priority Handling", "Dedicated Manager"]
    },
    // {
    //   icon: faGraduationCap,
    //   title: "Student Visas",
    //   description: "Specialized assistance for student visa applications",
    //   gradient: "from-orange-500 to-red-500",
    //   features: ["University Liaison", "Financial Planning", "Accommodation Help"]
    // },
    // {
    //   icon: faBriefcase,
    //   title: "Business Visas",
    //   description: "Corporate visa solutions for business travelers",
    //   gradient: "from-indigo-500 to-purple-500",
    //   features: ["Corporate Packages", "Multi-entry Visas", "Emergency Support"]
    // },
    
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-br from-slate-50 to-blue-50 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-cyan-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center mb-16" data-aos="zoom-in">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-blue-100 text-blue-600 text-sm font-medium mb-4">
            <span className="w-2 h-2 bg-blue-600 rounded-full mr-2 animate-pulse"></span>
            Our Services
          </div>
          <h2 className="text-2xl lg:text-5xl font-bold text-gray-900 mb-4 bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent">
            Comprehensive Visa Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            End-to-end visa services tailored to your unique needs with personalized support at every step
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index} data-aos="zoom-out"
              className="group relative bg-white rounded-3xl p-8 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 cursor-pointer border border-gray-100 overflow-hidden"
            >
              {/* Gradient Overlay */}
              <div className={`absolute inset-0 bg-gradient-to-br ${service.gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-500`}></div>
              
              {/* Icon */}
              <div className={`relative z-10 inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br ${service.gradient} text-white text-2xl mb-6 transform group-hover:scale-110 transition-transform duration-500 shadow-lg`}>
                <FontAwesomeIcon icon={service.icon}/>
              </div>
              
              {/* Content */}
              <h3 className="text-2xl font-bold text-gray-900 mb-4 relative z-10 group-hover:text-blue-600 transition-colors duration-300">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6 relative z-10">
                {service.description}
              </p>
              
              {/* Features */}
              <div className="space-y-2 relative z-10">
                {service.features.map((feature, idx) => (
                  <div key={idx} className="flex items-center text-sm text-gray-500 group-hover:text-gray-700 transition-colors duration-300">
                    <div className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-3 group-hover:scale-150 transition-transform duration-300"></div>
                    {feature}
                  </div>
                ))}
              </div>
              
              {/* Hover Border */}
              <div className={`absolute inset-0 rounded-3xl bg-gradient-to-r ${service.gradient} opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10`}>
                <div className="absolute inset-[2px] rounded-3xl bg-white"></div>
              </div>
            </div>
          ))}
        </div>
        
        {/* CTA Section */}
        <div className="text-center mt-16" data-aos="fade-down">
          <div className="bg-white rounded-2xl p-8 shadow-xl border border-gray-100 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Need Custom Visa Solutions?</h3>
            <p className="text-gray-600 mb-6">We provide personalized visa packages for complex requirements</p>
            <Link to='/contact'>
            <button className="bg-gradient-to-r from-blue-600 to-cyan-600 text-white px-8 py-4 rounded-xl font-semibold hover:shadow-xl transition-all duration-300 transform hover:scale-105">
              Get Custom Quote
            </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;